import { API_URL } from '@/config';
import { axios } from '@/lib/axios';
import { useQuery } from 'react-query';

export type TextbookListItem = {
    domainId: number;
    joveSectionId: number;
    name: string;
    edition?: number | null;
    author?: string | null;
    publisher?: { id: number; name: string } | null;
};

export type TextbookListResponse = {
    total: number;
    page: number;
    size: number;
    results: TextbookListItem[];
};

export type TextbookListParams = {
    search?: string;
    publisherId?: number | null;
    page: number;
    size: number;
};

const fetchTextbooks = (params: TextbookListParams): Promise<TextbookListResponse> => {
    const query: Record<string, string | number> = {
        page: params.page,
        size: params.size,
    };
    if (params.search) query.search = params.search;
    if (params.publisherId) query.publisherId = params.publisherId;
    return axios.get(`${API_URL}/api/v2/admin/quiz/library/textbook-list`, { params: query });
};

export const useTextbookList = (params: TextbookListParams) =>
    useQuery<TextbookListResponse>({
        queryKey: ['library-textbook-list', params],
        queryFn: () => fetchTextbooks(params),
        keepPreviousData: true,
        useErrorBoundary: (error: any) => error?.response?.status >= 400,
    });
